<template>
  <div class="modal__wrapper">
    <div class="modal__close">
      <div class="btn" @click="close">
        <Close class="img"/>
      </div>
    </div>
    <div class="modal__header">
      <div class="ttl">Create Business Offer</div>
    </div>
    <div class="modal__body">
      <div class="row">
        <div class="label">Type of Business</div>
        <div class="data">
          <input type="text" name="business_type" class="inpt" v-model="form.business_type">
        </div>
      </div>
      <div class="row">
        <div class="label">Type of License</div>
        <div class="data">
          <input type="text" name="license_type" class="inpt" v-model="form.license_type">
        </div>
      </div>
      <div class="row">
        <div class="label">Country</div>
        <div class="data">
          <select name="country_id" class="inpt" v-model="form.country_id">
            <option value="null">Select country</option>
            <option
              v-for="country in countries" :key="country.id"
              :selected="country.id === form.country_id"
              :value="country.id"
            >
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="label">Description</div>
        <div class="data">
          <textarea name="description" rows="5" class="inpt inpt__ta" v-model="form.description"/>
        </div>
      </div>
      <div class="row row__price">
        <div class="label">Price</div>
        <div class="data">
          <input type="text" name="price" class="inpt" v-model="form.price">
          <select v-if="currencies" v-model="form.currency_id">
            <option
              v-for="c in currencies" :key="c.id"
              :value="c.id"
              v-text="c.code"
            />
          </select>
        </div>
      </div>
      <span v-if="error && error.length > 0" class="invalid-feedback">{{ error }}</span>
    </div>
    <div class="modal__footer">
      <div class="btn" @click="save">Save</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Close from './../img/Close.vue'

export default {
  components: {
    Close
  },
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    countries: [],
    allCurrencies: null,
    form: {
      business_type: null,
      license_type: null,
      country_id: null,
      description: null,
      price: null,
      currency_id: null,
    },
    error: null
  }),
  computed: {
    isEdit () {
      return this.options && this.options.id && this.options.form
    },
    currencies () {
      if (!this.allCurrencies) return []

      return this.allCurrencies.filter(el => el.code === 'EUR' || el.code === 'USD')
    }
  },
  created () {
    this.getCurrencies()
    this.getCountries()
  },
  methods: {
    ...mapActions({
      createBusinessOffer: 'bos_business/createOffer',
      updateBusinessOffer: 'bos_business/updateOffer'
    }),
    updateForm () {
      if (!this.isEdit) return

      this.form.business_type = this.options.form.business_type
      this.form.license_type = this.options.form.license_type
      this.form.description = this.options.form.description
      this.form.price = this.options.form.price.price ? this.options.form.price.price : 0
      this.form.currency_id = this.options.form.price.currency ? this.options.form.price.currency.id : 2

      const country = this.countries.find(el => el.name === this.options.form.country_name)
      this.form.country_id = country && country.id ? country.id : null
    },
    getCurrencies () {
      axios.get('admin/data/currencies')
        .then(({ data }) => {
          this.allCurrencies = data
        })
        .catch(err => console.dir(err))
    },
    async getCountries () {
      await axios.get('admin/data/countries')
        .then(({data}) => {
          this.countries = data
          this.updateForm()
        })
        .catch((error) => {
          console.log(error);
        })
    },
    async save () {
      if (this.isEdit) {
        await this.updateBusinessOffer({ id: this.options.id, form: this.form })
          .then(res => this.close())
          .catch(error => console.log(error))
      } else {
        await this.createBusinessOffer(this.form)
          .then(() => {
            for (const key in this.form) {
              if (Object.hasOwnProperty.call(this.form, key)) {
                this.form[key] = null
              }
            }
            this.close()
          })
          .catch(error => console.log(error))
      }
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__wrapper {
    width: 40rem;
  }

  &__header {
    padding: 2.5rem 0.75rem 1.5rem;
  }

  &__body {
    flex-direction: column;
    align-content: flex-start;

    .row {
      width: 100%;
      display: flex;
      align-items: center;
      padding: .25rem 0;
      margin: .25rem 0 0;

      .label {
        min-width: 10rem;
        padding-right: .75rem;
        font-weight: bold;
      }

      .data {
        flex-grow: 1;

        .inpt {
          width: 100%;
          color: #000000;

          &__ta {
            height: 7rem;
          }
        }
      }

      &__price {
        .data {
          display: flex;

          input {
            margin-right: .75rem;
          }

          select {
            color: white;
            background-color: var(--c_more-black);
            padding: .25rem .5rem;
            border-radius: 6px;
          }
        }
      }
    }
  }

  &__footer {
    padding: 1rem 1.5rem 1.5rem;
  }
}
</style>
